<template>
  <div v-html="md.render(source)" />
</template>
<script setup lang="ts">
  import MarkdownIt from 'markdown-it'

  const md = new MarkdownIt()
  const defaultRender =
    md.renderer.rules.link_open ||
    function (tokens, idx, options, env, self) {
      return self.renderToken(tokens, idx, options)
    }

  md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    // Add a new `target` attribute, or replace the value of the existing one.
    const href = tokens[idx].attrGet('href')
    if (href && !href.startsWith('#')) tokens[idx].attrSet('target', '_blank')

    // Pass the token to the default renderer.
    return defaultRender(tokens, idx, options, env, self)
  }

  defineProps({
    source: {
      type: String,
      default: '',
    },
  })
</script>
<style lang="scss" scoped>
  div {
    :deep() {
      h1 {
        font-size: 24px;
      }
      h2 {
        font-size: 22px;
      }
      h3 {
        font-size: 20px;
      }
      h4,
      h5 {
        font-size: 18px;
      }
      a {
        text-decoration: underline;
      }
      ul,
      ol {
        margin-bottom: 1.25em;
        margin-top: 1.25em;
        padding-left: 1.2em;
      }
      ol {
        list-style-type: decimal;
        &[type='A'] {
          list-style-type: upper-alpha;
        }
        &[type='a'] {
          list-style-type: lower-alpha;
        }
        &[type='I'] {
          list-style-type: upper-roman;
        }
        &[type='i'] {
          list-style-type: lower-roman;
        }
      }
      ul {
        list-style-type: disc;
      }
      li {
        // padding-left: 0.375em;
        margin-bottom: 0.5em;
        margin-top: 0.5em;
      }
      hr {
        border-color: white;
        border-top-width: 1px;
        margin-bottom: 3em;
        margin-top: 3em;
      }
    }
  }
</style>
